import { render, staticRenderFns } from "./buttonIcon.vue?vue&type=template&id=6d3f9283&scoped=true&"
import script from "./buttonIcon.vue?vue&type=script&lang=js&"
export * from "./buttonIcon.vue?vue&type=script&lang=js&"
import style0 from "./buttonIcon.vue?vue&type=style&index=0&id=6d3f9283&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3f9283",
  null
  
)

export default component.exports